import addShouldDisableUnshareToAnnotation from "../addShouldDisableUnshareToAnnotation";

const getAnnotationsToShow = (
  user,
  allStudentAndTeacherAnnotations,
  isStudentPreviewOn,
) => {
  if (user?.student) {
    return allStudentAndTeacherAnnotations;
  }
  // Teachers only see their own annotations
  const teacherAnnotations = allStudentAndTeacherAnnotations?.filter(
    (annotation) => annotation?.user?.id === user.id,
  );

  // If student preview is on, filter out saved annotations and only show shared annotations.
  if (isStudentPreviewOn) {
    const sharedAnnotations = teacherAnnotations?.filter(
      (annotation) => !!annotation.date_shared,
    );
    return addShouldDisableUnshareToAnnotation(
      allStudentAndTeacherAnnotations,
      sharedAnnotations,
    );
  }

  return addShouldDisableUnshareToAnnotation(
    allStudentAndTeacherAnnotations,
    teacherAnnotations,
  );
};

export default getAnnotationsToShow;
